<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">认证权限 /</div>
        <div class="box-header-right"><div>角色管理</div></div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan">
        <div class="botton-box">
          <el-button size="mini" class="addButton" @click="getchildeditDialog"
            >添加</el-button
          >
        </div>
        <div class="biaodan-left">
          <div style="height: 100%">
            <el-form
              :inline="true"
              label-position="right"
              class="demo-form-inline"
              :model="form"
            >
              <!-- <el-form-item label="部门名称">
                <el-input
                  v-model="form.deptName"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入部门名称"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="角色名称">
                <el-input
                  v-model="form.roleName"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入角色名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="角色代码">
                <el-input
                  v-model="form.roleCode"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入角色代码"
                ></el-input>
              </el-form-item>
              <el-form-item label="角色类型">
                <el-select
                  style="width: 150px"
                  size="mini"
                  placeholder="请选择角色类型"
                  clearable
                  v-model="form.roleType"
                  filterable
                >
                  <el-option
                    v-for="item in roleTypeList"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button
                  type="primary"
                  @click="onSearch"
                  class="search"
                  size="mini"
                  >查询</el-button
                >
                <el-button
                  type="primary"
                  @click="onReset"
                  class="search"
                  size="mini"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table
              class="table_name"
              highlight-current-row
              :data="tableData"
              row-class-name="classname"
              row-key="id"
              border
              :header-cell-style="{
                background: '#F3F8FE',
                color: '#333333',
                textAlign: 'center'
              }"
              lazy
              :load="treeLoadSon"
              @selection-change="handleSelectionChange"
              :tree-props="{ children: 'children', hasChildren: 'haveSon' }"
              max-height="650"
            >
              <el-table-column
                align="center"
                prop="roleName"
                label="角色名称"
                width="280"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.data.roleName }}</div>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                prop="roleCode"
                label="角色代码"
                width="280"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.data.roleCode }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="roleType" label="角色类型" width="150">
                <template slot-scope="scope">
                  <div v-for="(item, index) in roleTypeList" :key="index">
                    <div v-if="scope.row.data.roleType == item.value">
                      {{ item.text }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="创建时间"
                width="300"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.data.createTime }}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="备注"
                width="300"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.data.remark }}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="340">
                <template slot-scope="scope">
                  <el-button
                    style="margin-left: 10px; color: #3666EA"
                    type="text"
                    @click="getValueDialog(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    style="margin-left: 10px; color: #3666EA"
                    type="text"
                    @click="relation(scope.row)"
                    >权限分配</el-button
                  >
                  <el-popconfirm
                    title="确定删除吗？"
                    trigger="click"
                    @confirm="deleteType(scope.row)"
                  >
                    <el-button
                      style="margin-left: 10px; color: #ed6363"
                      type="text"
                      slot="reference"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
            :page-size="page.size"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            :style="{ textAlign: 'right', marginTop: '20px' }"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="formData"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item prop="roleName" label="角色名称">
            <el-input
              v-model="formData.roleName"
              placeholder="角色名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="roleCode" label="角色代码">
            <el-input
              v-model="formData.roleCode"
              placeholder="角色代码"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色类型" prop="roleType">
            <el-select
              size="medium"
              placeholder="请选择角色类型"
              clearable
              v-model="formData.roleType"
              filterable
            >
              <el-option
                v-for="item in roleTypeList"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="formData.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          class="search"
          size="mini"
          @click="cancelcerat"
        >
          <span>确 定</span>
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="权限分配"
      width="800px"
      :modal="true"
      class="user-dialog"
      :close-on-click-modal="false"
      :visible.sync="isformPermission"
    >
      <el-tree
        :data="roleRreeList"
        ref="tree"
        show-checkbox
        node-key="uuid"
        :default-expand-all="true"
        :check-strictly="isCheck"
        :props="defaultProps"
        class="tree"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <div class="tree-box">
            <div class="tree-box">
              <div>{{ node.label }}</div>
            </div>
          </div>
        </span>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isformPermission = false" size="mini"
          >取 消</el-button
        >
        <el-button
          type="primary"
          class="search"
          @click="RoleAuthorization"
          size="mini"
        >
          <span>确 定</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getRoleList,
  setRoleSave,
  setRoleGrant,
  setMenuTree,
  listAll,
  roleApp,
  appList,
  bindApp,
  getDeptTree
} from "@/api/systemManagement";
import { getRoleRoot } from "../../../api/systemManagement";
import "./iconfont/iconfont.css";
export default {
  props: {},
  data() {
    const _self = this;
    return {
      isCheck: false,
      visible: false,
      deptTree: [],
      roleValue: [],
      DepartmentList: [],
      tableDataTwo: [],
      roleList: [],
      roleData: [],
      sts: null,
      isShearch: true,
      currentPage: 1,
      isformPermission: false,
      dialogVisibleTwo: false,
      currentPageTwo: "1",
      relationUser: false,
      dialogVisible: false,
      passwordVisible: false,
      formPermission: {
        id: null,
        roleIds: []
      },
      havePermIds: [],
      totalTwo: "",
      superAdminList: [
        { value: 1, label: "是" },
        { value: 0, label: "否" }
      ],
      defaultProps: {
        children: "children",
        label: "label",
        checkStrictly: false
      },
      roleTree: [],
      roleTypeList: [
        {
          text: "平台角色",
          value: 1
        },
        {
          text: "客服角色",
          value: 3
        }
      ],
      ruleForm: {
        accountName: "",
        userName: "",
        password: "",
        deptId: "",
        userType: 1,
        phone: "",
        idNo: null,
        email: "",
        jobinfo: "",
        status: 1,
        id: ""
      },
      passwordForm: {
        newPassword: "",
        old: "",
        towPassword: ""
      },
      entryList: [],
      optionList: [],
      total: null,
      title: "添加角色",
      titleTwo: "查看配置基本信息",
      // currentPage: 1,
      form: {
        roleCode: "",
        roleType: null,
        roleName: "",
        deptName: ""
      },
      tableData: [],
      page: {
        page: 1,
        size: 10
      },
      formData: {
        roleName: "",
        roleType: "",
        // superAdmin: 0,
        roleCode: "",
        id: null,
        remark: ""
      },
      roleRreeList: [],
      viewFormData: {
        status: null,
        accountName: null,
        userName: null,
        password: null,
        deptId: null,
        mail: null,
        idNo: null,
        phone: null,
        userType: null,
        jobinfo: null
      },
      pageTwo: {
        page: 1,
        size: 10
      },
      choiceList: [],
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" }
        ],
        roleCode: [
          { required: true, message: "请输入角色代码", trigger: "blur" }
        ]
      },
      props: {
        value: "id",
        label: "label",
        children: "children",
        checkStrictly: true
      },
      deptprops: {
        value: "deptCode",
        label: "label",
        children: "children",
        checkStrictly: true,
        lazy: true, //设置lazyLoad，必须配合lazy：true
        async lazyLoad(node, resolve) {
          // 区域树懒加载的方法
          const { data } = node;
          if (
            (data && data.haveSon === false) ||
            (data && data.leaf === true)
          ) {
            return resolve([]);
          }
          let id;
          if (data) {
            id = data.id;
          } else {
            return resolve([]);
          }
          const temp = await _self.getSta(id);
          let tempData = [];
          for (const item of temp.data) {
            tempData.push({
              ...item,
              leaf: item.level === "city",
              ...item.data
            });
          }
          resolve(tempData);
        }
      },
      kindId: null,
      roleId: null
    };
  },
  mounted() {
    this.queryDictionaries();
    // this.getUserStatus();
    this.getTree();
  },
  methods: {
    // 获取部门资源树形
    async getTree() {
      let params = {
        name: "",
        id: "",
        deptCode: JSON.parse(sessionStorage.getItem("userInfo")).detpCode,
        data: true
      };
      const res = await getDeptTree(params);
      if (res.data.code == 200) {
        this.deptTree = [];
        res.data.data.forEach(item => {
          this.deptTree.push({
            ...item,
            ...item.data
          });
        });
        if (this.deptTree.length) this.deptTree[0].haveSon = true;
      }
    },
    async getSta(pid) {
      const params = {
        name: "",
        id: "",
        pid: pid,
        data: true
      };
      const data = await getDeptTree(params);
      console.log(data);
      return data.data;
    },
    async treeLoadSon(tree, treeNode, resolve) {
      let params = {
        roleCode: this.form.roleCode,
        roleName: this.form.roleName,
        roleType: this.form.roleType,
        deptName: this.form.deptName,
        page: this.page.page,
        size: this.page.size,
        data: true,
        pid: tree.data.id
      };
      const res = await getRoleList(params);
      // let result = res.data
      // const res = await getDeptTreet(params);
      return resolve(res.data.data);
    },
    // onroleId(val){
    //   console.log(val)
    // },
    // 获取角色权限树形
    // async roleRree(){
    //
    // },
    roleChange(val) {
      this.formPermission.roleIds = val;
    },
    async relation(val) {
      let params = {
        roleId: val.id
      };
      const res = await setMenuTree(params);
      if (res.data.code == 200) {
        this.havePermIds = [];
        res.data.data.map(item => {
          let is = "children";
          if (item.check == 1) {
            this.havePermIds.push(item.uuid);
          }
          if (item.haveSon == true) {
            if (item.children.length) {
              item.children.map(ites => {
                if (ites.check == 1) {
                  this.havePermIds.push(ites.uuid);
                }
                if (ites.haveSon == true) {
                  if (ites.children.length) {
                    ites.children.map(iteg => {
                      if (iteg.check == 1) {
                        this.havePermIds.push(iteg.uuid);
                      }
                      if (iteg.haveSon == true) {
                        if (iteg.children.length) {
                          iteg.children.map(iteb => {
                            if (iteb.check == 1) {
                              this.havePermIds.push(iteb.uuid);
                            }
                            if (iteb.haveSon == true) {
                              if (iteb.children.length) {
                                iteb.children.map(itebs => {
                                  if (itebs.check == 1) {
                                    this.havePermIds.push(itebs.uuid);
                                  }
                                });
                              }
                            }
                          });
                        }
                      }
                    });
                  }
                }
              });
            }
          }
        });
        this.isformPermission = true;
        this.isCheck = true;
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys(this.havePermIds);
          this.isCheck = false;
        });
        this.roleRreeList = res.data.data;
      }
      this.formPermission.id = val.id;
    },
    async RoleAuthorization() {
      var addTree = this.$refs.tree.getCheckedNodes();
      let parentsArray = this.$refs.tree.getHalfCheckedNodes() || [];
      var funs = [];
      for (var s = 0; s < addTree.length; s++) {
        funs.push({
          resourceId: addTree[s].id,
          resourceType: addTree[s].type
        });
      }
      if (parentsArray && parentsArray.length > 0) {
        parentsArray.map(item => {
          funs.push({
            resourceId: item.id,
            resourceType: item.type
          });
        });
      }
      let params = {
        roleId: this.formPermission.id,
        resourceList: funs
      };
      const res = await setRoleGrant(params);
      if (res.data.code == 200) {
        this.$message({
          message: "权限分配成功",
          type: "success"
        });
        this.isformPermission = false;
      }
    },
    resetPassword(val) {
      this.passwordVisible = true;
    },
    handleChange(val) {
      this.formData.pid = val[val.length - 1];
    },
    deptHandleChange(val) {
      this.formData.deptCode = val[val.length - 1];
    },
    handleSelectionChange(val) {
      this.choiceList = val;
    },
    GetUser(val) {
      this.viewFormData.status = val.status;
      this.viewFormData.accountName = val.accountName;
      this.viewFormData.userName = val.userName;
      this.viewFormData.password = val.password;
      this.viewFormData.deptId = val.deptId;
      this.viewFormData.mail = val.mail;
      this.viewFormData.idNo = val.idNo;
      this.viewFormData.phone = val.phone;
      this.viewFormData.userType = val.userType;
      this.viewFormData.jobinfo = val.jobinfo;
      this.visible = true;
    },
    async getValueDialog(val) {
      this.dialogVisible = true;
      this.getRoleTree(val.data.id);
      this.title = "编辑角色信息";
      this.formData.roleName = val.data.roleName;
      this.formData.roleType = val.data.roleType;
      this.formData.roleCode = val.data.roleCode;
      this.formData.id = val.data.id;
      this.formData.remark = val.data.remark;
      console.log(this.formData);
    },
    // 删除用户
    async deleteType(val) {
      if ((this.total - 1) % this.page.size === 0) {
        if (this.page.page > 1) {
          this.page.page -= 1;
        }
      }
      this.$axios
        .delete(
          `${process.env.VUE_APP_API_DOMAIN}/tbase-iam-manage/role/delete/${val.id}`
        )
        .then(res => {
          if (res.data.code == 200) {
            this.queryDictionaries();
          } else {
            this.$message({
              message: `${res.data.msg}`,
              type: "warning"
            });
          }
        });
    },
    async cancelcerat() {
      if (
        this.formData.roleName == null ||
        this.formData.roleName == "" ||
        this.formData.roleCode == null ||
        this.formData.roleCode == ""
      ) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let params = {
        roleCode: this.formData.roleCode,
        roleName: this.formData.roleName,
        roleType: this.formData.roleType,
        // superAdmin: this.formData.superAdmin,
        id: this.formData.id,
        remark: this.formData.remark,
        createBy: 0,
        updateBy: 0
      };
      const res = await setRoleSave(params);
      if (res.data.code == 200) {
        this.formData.roleCode = null;
        this.formData.roleName = null;
        this.formData.roleType = null;
        // this.formData.superAdmin = null;
        this.formData.id = null;
        this.formData.remark = "";
        this.queryDictionaries();
        this.dialogVisible = false;
        this.$message({
          message: "保存成功",
          type: "success"
        });
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    getchildeditDialog(num) {
      this.getRoleTree();
      this.formData.roleCode = null;
      this.formData.roleName = null;
      this.formData.roleType = 1;
      // this.formData.superAdmin = 0;
      this.formData.id = null;
      this.dialogVisible = true;
      this.formData.remark = "";
    },
    handleSizeChange(val) {
      this.page.size = val;
      if (this.isShearch == true) {
        this.queryDictionaries();
      } else {
        this.queryDictionaries("search");
      }
    },
    handleCurrentChange(val) {
      this.page.page = val;
      if (this.isShearch == true) {
        this.queryDictionaries();
      } else {
        this.queryDictionaries("search");
      }
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.Size = 10;
      this.isShearch = false;
      // this.currentPage = 1;
      this.queryDictionaries("search");
    },
    onReset() {
      this.form.roleCode = "";
      this.form.roleName = "";
      this.form.deptName = "";
      this.form.roleType = null;
      this.page.page = 1;
      this.page.size = 10;
      this.currentPage = 1;
      this.isShearch = true;
      this.queryDictionaries();
    },
    // 查询用户列表
    async queryDictionaries(val) {
      let params = {
        roleCode: this.form.roleCode,
        roleName: this.form.roleName,
        roleType: this.form.roleType,
        deptName: this.form.deptName,
        page: this.page.page,
        size: this.page.size,
        data: true,
        pid: -1
      };
      if (val) {
        params.pid = "";
      } else {
        params.pid = "";
      }
      const res = await getRoleRoot(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.dataList ? res.data.data.dataList : [];
        this.total = res.data.data.total ? Number(res.data.data.total) : 0;
        // this.roleTree = this.tableData
      }
    },
    async getRoleTree(val) {
      if (val) {
        let params = {
          roleCode: "",
          roleName: "",
          roleType: "",
          data: false,
          excludeId: val
        };
        const res = await getRoleList(params);
        if (res.data.code == 200) {
          this.roleTree = res.data.data;
        }
      } else {
        let params = {
          roleCode: "",
          roleName: "",
          roleType: "",
          data: false
        };
        const res = await getRoleList(params);
        if (res.data.code == 200) {
          this.roleTree = res.data.data;
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
.box-father {
  height: 100%;
  width: 100%;
  padding: 0px 20px 20px 20px;
  background-color: #fff;
}
.box-header {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
}
.box-header-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.box-header-left-text {
  width: 120px;
  height: 14px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #b2b3c9;
  line-height: 21px;
  display: flex;
  align-items: center;
}
.box-header-right {
  font-weight: 400;
  color: #004ad1;
  line-height: 21px;
  width: 90%;
  height: 81%;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
.section {
  height: 94.9%;
  background-color: #fff;
}
.el-menu-item.is-active {
  background: rgb(59, 121, 203, 0.2) !important;
}
.el-menu-item:hover {
  color: #1e90ff;
}
.daohang {
  display: flex;
  margin-left: 15px;
}
.daohang .el-menu-item {
  width: 100px;
  margin-left: 20px;
}
.biaodan {
  width: 100%;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  .form-item {
    padding: 0;
    margin: 0;
  }
}
.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.biaodan-left .el-form-item {
  margin-bottom: 0px;
}
.demo-form-inline {
  height: 100%;
  display: flex;
  //align-items: center;
  justify-content: space-between;
}
.export {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
/* .aside{
  height: 100%;
}
.disTable{
  height: 100%;
} */
.element.style {
  height: 570px;
}
/* .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 -28px !important;
} */
///deep/ .el-tabs__item {
//  height: 45px !important;
//  margin-top: 15px;
//}
.form-box {
  width: 100%;
  //display: flex;
  //flex-wrap: wrap;
  margin-top: 10px;
}
.form-content {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.form-item {
  display: flex;
  justify-content: left;
}
.form-content-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ ::-webkit-scrollbar-thumb {
  background-color: #dbdde3;
  border-radius: 5px;
}
.botton-box {
  width: 20%;
  height: 50px;
  display: flex;
  align-items: center;
}

.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}
//.el-form--inline .el-form-item__content {
//  width: 70%;
//}
.section .el-form-item__label {
  text-align: left;
}

.addValueDialog .el-form--inline .el-form-item {
  width: 100%;
}
.black {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
/deep/ .el-dialog__wrapper .addValueDialog .el-form-item__label {
  width: 130px !important;
}
.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}
.passWordForm {
  .el-form-item__content {
    width: 70%;
    display: flex !important;
    justify-content: space-between;
    align-items: baseline;
    margin-top: -43px;
    margin-left: 95px;
  }
}

.updatePassword {
  width: 70px;
  height: 36px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background: #0495ff;
  border-radius: 10%;
}
#character {
  .el-dialog {
    height: 860px;
    overflow: scroll;
  }

  .el-form-item__label {
    width: 95px;
  }

  .Permission_form {
    display: flex;
    justify-content: space-around;
    .roleLabel {
      color: #606266;
      font-size: 14px;
      font-weight: 800;
    }
    .el-form-item__content {
      width: 78.5%;
      height: 45px;
    }
  }

  .div-tag {
    width: auto;
    display: inline-block;
    position: relative;
    bottom: 41px;
    left: 4px;
    height: 40px;
    max-width: 450px;
    overflow-y: hidden;
    overflow-x: scroll;
    white-space: nowrap;
  }

  .test-1::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }

  .test-1::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }

  .character .el-dialog__body .data-d {
    height: 345px;
  }
  .pass {
    .el-dialog {
      margin-top: 33vh !important;
      width: 23% !important;
      height: 433px !important;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
  }
}
/deep/.v-modal {
  z-index: 2000 !important;
}
.user-dialog {
  .el-form-item {
    margin-bottom: 10px;
    width: 45% !important;
  }
}
.character .el-dialog__body form {
  padding-bottom: 0;
}
.tree {
  height: 300px;
  background-color: #fff;
  overflow: auto;
}
.tree-class .el-tree-node__content {
  &:hover {
    background-color: #dfeafb;
  }
}
.el-message {
  z-index: 2222 !important;
}
.tree-d {
  .el-form-item__content {
    position: relative;
    & > .el-input {
      position: absolute;
      z-index: 2;
    }
  }
}
.word {
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    margin-left: 25px;
  }
}
.guanlian {
  margin-left: 88px;
}
///deep/.table_name .cell{
//  display: flex;
//  //align-items: center;
//  //height: 30px;
//  //text-align: center;
//}
/deep/ .el-tree {
  // 将每一行的设置为相对定位 方便后面before after 使用绝对定位来固定位置
  .el-tree-node {
    position: relative;
    padding-left: 10px;
  }
  // 子集像右偏移 给数线留出距离
  .el-tree-node__children {
    padding-left: 10px;
  }
  //这是竖线
  .el-tree-node :last-child:before {
    height: 40px;
  }
  .el-tree > .el-tree-node:before {
    border-left: none;
  }
  .el-tree > .el-tree-node:after {
    border-top: none;
  }
  //这自定义的线 的公共部分
  .el-tree-node:before,
  .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }
  .tree :first-child .el-tree-node:before {
    border-left: none;
  }
  // 竖线
  .el-tree-node:before {
    border-left: 1px solid #d8d8d8;
    bottom: 0px;
    height: 100%;
    top: -25px;
    width: 1px;
  }
  //横线
  .el-tree-node:after {
    border-top: 1px solid #d8d8d8;
    height: 20px;
    top: 14px;
    width: 30px;
  }
  //.el-tree-node__expand-icon.is-leaf {
  //  width: 20;
  //}
  //每一行的高度
  .el-tree-node__content {
    line-height: 30px;
    height: 30px;
    margin-left: 0px;
  }
}
//去掉最上级的before  after 即是去电最上层的连接线
/deep/ .el-tree > div {
  &::before {
    display: none;
  }
  &::after {
    display: none;
  }
}
.element.style {
  margin-left: 10px !important;
}
/deep/ .el-tree-node__content {
  padding-left: 10px !important;
}
.tree-box {
  display: flex;
  align-items: center;
  width: 100%;
}
.iconfont {
  margin-right: 10px;
  color: rgb(255, 207, 92);
}
/deep/ .table_name {
  table {
    tbody {
      tr {
        td:nth-child(1) .cell {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
/deep/ .table_name {
  table {
    tbody {
      tr {
        td:nth-child(1) {
          text-align: center;
        }
      }
    }
  }
}
///deep/ .table_name table tbody tr td:nth-child(3) {
//  text-align: left;
//  display: flex;
//  background-color: red;
//}
///deep/ .table_name table tbody tr td:nth-child(3).cell {
//  text-align: left;
//  display: flex;
//}
.aside .el-button {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/roleManagement/index.vue